












import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import { PermissionValue } from "@/enums/PermissionValue";
import { RowTable } from "@/typings/BRowTable";
import BaseVue from "../../core/BaseVue";
import * as Quill from "quill";
import * as quillBetterTable from "quill-better-table";
//import * as wordCounter from "quill-wordcounter"; 

@Component({})
export default class QuillEditor extends BaseVue {
  @Prop({ default: "editor" }) editorId: string;
  @Prop({}) wordsCounted: number;
  @Prop({}) textLength: number;
  @Prop({default: false}) limitLength: boolean;
  @Prop({}) data: string;
  quill: any = null;
  wordsCounted_: number = 0;


  mounted() {
    Quill.register({ "modules/better-table": quillBetterTable }, true);
    Quill.register('modules/counter', function(quill, options) {
      var container = document.querySelector(options.container);
      quill.on('text-change', function() {
        var text = quill.getText();
        if (options.unit === 'word') {
          container.innerText = text.split(/\s+/).length + ' words';
        } else {
          container.innerText = text.length + ' characters';
        }
      });
    });

    let toolbarOptions = [
      ["bold", "italic", "underline", "strike"],
      ["blockquote", "code-block"],
      [{ header: 1 }, { header: 2 }],
      [{ list: "ordered" }, { list: "bullet" }],
      [{ script: "sub" }, { script: "super" }],
      [{ indent: "-1" }, { indent: "+1" }],
      [{ direction: "rtl" }],
      [{ size: ["small", false, "large", "huge"] }],
      [{ header: [1, 2, 3, 4, 5, 6, false] }],
      ["link", "image", "video", "formula"],
      [{ color: [] }, { background: [] }],
      [{ font: [] }],
      [{ align: [] }],
      ["clean"]
    ];
    this.quill = new Quill(`#${this.editorId}`, {
      theme: "snow",
      modules: {
        toolbar: toolbarOptions,
        table: true,
        //formula: true,
        "better-table": {
          operationMenu: {
            items: {
              unmergeCells: {
                text: "Another unmerge cells name"
              }
            },
            color: {
              colors: ["green", "red", "yellow", "blue", "white"],
              text: "Background Colors:"
            }
          }
        },
        keyboard: {
          bindings: quillBetterTable.keyboardBindings
        },
        wordCount: true,
        counter: {
          container: '#counter',
          unit: 'word'
        }
      }
    });

    
  }

  addTable() {
    let tableModule = this.quill.getModule("better-table");
    tableModule.insertTable(3, 3);
  }

  @Watch("wordsCounted")
  onWordsCounted(oldValue, newValue) {
    if (this.limitLength && this.wordsCounted >= 250) {
      let self = this;
      self.quill.on('text-change', function (delta, old, source) {
        if (self.quill.getLength() > self.textLength) {
          self.quill.deleteText(self.textLength, self.quill.getLength());
        }
      });
    }
  }

  @Watch("data")
  onDataLoad(oldValue, newValue) {
    if (this.data && this.data != "") {
      this.quill.root.innerHTML = this.data;
    }
  }

  @Watch("quill", { deep: true, immediate: true })
  onQuillContentChange(oldValue, newValue) {
    if (this.quill) {
      this.$emit("getText", this.quill.getText().trim());
      this.$emit("updateContent", {data: this.quill.root.innerHTML, length: this.quill.getText().trim().length});
    }
  }
}
